import * as React from "react";
import type { SVGProps } from "react";
const SvgUpgrade = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#upgrade_svg__a)">
      <path d="M19 22H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1M12 18c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v14c0 .55-.45 1-1 1" />
      <path d="M17 9c-.26 0-.51-.1-.71-.29L12 4.41l-4.29 4.3A.996.996 0 1 1 6.3 7.3l4.99-5.01a.996.996 0 0 1 1.41 0l5 5a.996.996 0 0 1-.71 1.7z" />
    </g>
    <defs>
      <clipPath id="upgrade_svg__a">
        <path fill="#fff" d="M4 2h16v20H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgUpgrade;
